export const loadPortfolioFromHistory = (portfolioId) => (dispatch, getState) => {

    const state = getState();

    // Find the given portfolio from the history (should already be loaded)
    const portfolioList = state.history.filter(port => port.id === portfolioId);

    // If the portfolio exists then load it into the UI
    if (portfolioList.length > 0) {

        const portfolioToLoad = portfolioList[0];
        dispatch({ type: 'CLEAR_AND_LOAD_PORTFOLIO', portfolio: portfolioToLoad });
        return;
    }

    // In the small cases where we may not have the portfolio in the history - either its a Proposed
    // or it hasn't been added back yet from the Personal Strategies app then go and get the
    // portfolio and add it to the History
    if (portfolioList.length === 0) {
        const { clientEmail, token } = getState();

        const url = `${process.env.REACT_APP_API_URL}/portfolio/lookup/`;
        fetch(`${url}?clientEmail=${clientEmail}&id=${portfolioId}`, {
            headers: {
                Authorization: token &&
                    `Token ${token}`,
            },
        })
            .then(d => {
                if (d.status === 404 || d.status === 403 ) {
                    dispatch({ type: 'CLEAR_ANALYSIS'})
                }
                return d.json()
            })
            .then(data => {                
                dispatch({ type: 'CLEAR_AND_LOAD_PORTFOLIO', portfolio: data });
            })
            .catch(error => {
                console.error(error);
                dispatch({ type: 'CLEAR_ANALYSIS'})
            });
    }

}


// WEBPACK FOOTER //
// ./src/actions/load-portfolio.js